import { css, useTheme } from '@emotion/react';
import { Skeleton } from '../Skeleton';

export const ProductCardSkeleton = () => {
  const theme = useTheme();
  const productCardSkeleton = css`
    ${theme.widgets.Product?.productCardSkeleton}
  `;

  return (
    <div css={productCardSkeleton} data-test="productCardSkeleton">
      <Skeleton height={320} mt={0} radius="sm" />
      <div className="product-title">
        <Skeleton height={16} mt={8} width={300} radius="sm" />
        <Skeleton height={16} mt={10} width={100} radius="sm" />
        <div className="product-rating">
          <Skeleton height={8} mt={0} width={190} radius="sm" />
        </div>
        <div className="product-price">
          <Skeleton height={8} mt={6} width={140} radius="sm" />
        </div>
        <div className="product-add">
          <Skeleton height={52} mt={12} width={154} radius="sm" />
        </div>
      </div>
    </div>
  );
};
